import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    template: '',
    styleUrls: ['../message.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PreparingComponent {}
